module.exports = __webpack_public_path__ + "media/IBMPlexSans-SemiBold.woff2";


//////////////////
// WEBPACK FOOTER
// ./src/fonts/IBMPlexSans/IBMPlexSans-SemiBold.woff2
// module id = 1470
// module chunks = 58